import React from 'react';
import { Routes, Route } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import StoryListPage from './pages/StoryListPage';
import StoryDetailPage from './pages/StoryDetailPage';
import CreateStoryPage from './pages/CreateStoryPage';
import RelayEditorPage from './pages/RelayEditorPage';
import UserProfilePage from './pages/UserProfilePage';
import DashboardPage from './pages/DashboardPage';
import AdminConsolePage from './pages/AdminConsolePage';

function App() {
  return (
    <Routes>
      {/* 主布局 - 左中右三栏 */}
      <Route path="/" element={<MainLayout />}>
        <Route index element={<HomePage />} />
        <Route path="stories" element={<StoryListPage />} />
        <Route path="stories/:id" element={<StoryDetailPage />} />
        <Route path="create" element={<CreateStoryPage />} />
        <Route path="relay/:storyId" element={<RelayEditorPage />} />
        <Route path="chapter/:chapterId" element={<RelayEditorPage />} />
        <Route path="profile/:id" element={<UserProfilePage />} />
        <Route path="dashboard" element={<DashboardPage />} />
      </Route>

      {/* 独立页面 */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      
      {/* 后台控制台 */}
      <Route path="/admin" element={<AdminConsolePage />} />
    </Routes>
  );
}

export default App;
